import { DEFAULT_NOTIFICATION_SETTINGS, type NotificationSettings } from '@nexus/core';
import type { Store } from '@nexus/store';
import { useStoreQuery } from '../db/context';

const KEY = 'notification_settings';

/** Stored settings merged over the defaults (new options get their default). */
export async function loadNotificationSettings(store: Store): Promise<NotificationSettings> {
  const raw = await store.getSetting(KEY);
  if (!raw) return DEFAULT_NOTIFICATION_SETTINGS;
  try {
    const saved = JSON.parse(raw) as Partial<NotificationSettings>;
    const d = DEFAULT_NOTIFICATION_SETTINGS;
    return {
      ...d,
      ...saved,
      quietHours: { ...d.quietHours, ...saved.quietHours },
      dueRule: { ...d.dueRule, ...saved.dueRule },
      highPriorityDayBefore: { ...d.highPriorityDayBefore, ...saved.highPriorityDayBefore },
      dailySummary: { ...d.dailySummary, ...saved.dailySummary },
      weeklySummary: { ...d.weeklySummary, ...saved.weeklySummary },
    };
  } catch {
    return DEFAULT_NOTIFICATION_SETTINGS;
  }
}

export async function saveNotificationSettings(
  store: Store,
  s: NotificationSettings,
): Promise<void> {
  await store.setSetting(KEY, JSON.stringify(s));
  store.notifyChange(['notifications']);
}

export function useNotificationSettings(): NotificationSettings | undefined {
  return useStoreQuery((s) => loadNotificationSettings(s), [], ['notifications']);
}
